import { PriceService } from "../models/priceService.model";
import { PriceUploadExcelViewModel } from "./priceUploadExcel.viewModel";
export class PriceServiceDetailExcelViewModel {
    areaCodes: string[] = [];
    WeightCodes:string[] = [];
    priceServiceViewModel: PriceService = new PriceService();
    priceUploadExcelViewModel: PriceUploadExcelViewModel[] = [];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/priceServiceDetailExcel.viewModel.ts